import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M70.412,6.867H29.588A7.394,7.394,0,0,0,22.2,14.252v71.5a7.394,7.394,0,0,0,7.386,7.385H70.412A7.394,7.394,0,0,0,77.8,85.748v-71.5A7.394,7.394,0,0,0,70.412,6.867ZM27.126,24.612H72.874V68.925H27.126Zm2.462-12.821H70.412a2.463,2.463,0,0,1,2.462,2.461v5.436H27.126V14.252A2.463,2.463,0,0,1,29.588,11.791ZM70.412,88.209H29.588a2.463,2.463,0,0,1-2.462-2.461v-11.9H72.874v11.9A2.463,2.463,0,0,1,70.412,88.209ZM54.461,80.977A4.461,4.461,0,1,1,50,76.516,4.467,4.467,0,0,1,54.461,80.977Z'

const IconSmartphone: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} />
)

export default IconSmartphone
